import http from "../utils/http";

export const getActiveNews = async (): Promise<Response> => {
  return await http.get("/api/news/active");
};

export const setAsRead = async (id: number): Promise<Response> => {
  return await http.get(`/api/news/${id}/show-no-more`);
};
